/**
 * wallArt — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const wallArtPack: ToilePack = {
    slug: 'wall-art',
    category: 'wallart',
    name: 'Printable wall art',
    tagline: tagline('prints', 'subjects', 'styles'),
    chips: chips('subjects', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'abstract', label: 'Organic shapes', subject: 'overlapping blobs, arcs and one full circle'},
        {key: 'ocean', label: 'Ocean horizon', subject: 'water, a low sun and a pale sky in broad calm bands'},
        {key: 'desert', label: 'Desert botanicals', subject: 'an agave, a prickly pear pad and dried grasses'},
    ],
    styles: [
        {key: 'midcentury', label: 'Mid-century', style: 'flat geometric shapes, printed grain', palette: 'mustard, burnt orange, cream, charcoal', framing: 'balanced, clear margin, no frame'},
        {key: 'lineart', label: 'Single line', style: 'one continuous thin black line, no fills', palette: 'black on off-white', framing: 'balanced, clear margin, no frame'},
        {key: 'textured', label: 'Textured paint', style: 'thick brush and palette-knife strokes', palette: 'tonal earths, raw canvas at the edges', framing: 'balanced, clear margin, no frame'},
    ],
    directions: ['mountains instead', 'in black and white only', 'calmer, with fewer shapes'],
}
